import * as React from 'react';

import { Image } from '../Image';

const icon = require('../../assets/clipboard-icon.png');

export function ClipboardIcon(props: Partial<React.ComponentProps<typeof Image>>) {
  return <Image source={icon} {...props} />;
}
